export class StaticUtilities {
    static traverseLayoutTree(layout, callback, order) {
        if (layout === null) {
            return;
        }
        if (order === 'pre-order') {
            callback(layout);
        }
        if (layout.type !== 'stack') {
            for (const item of layout.items) {
                StaticUtilities.traverseLayoutTree(item.child, callback, order);
            }
        }
        if (order === 'post-order') {
            callback(layout);
        }
    }
    static minimizeLayout(layout) {
        if (layout === null) {
            return null;
        }
        switch (layout.type) {
            case 'column':
            case 'row': {
                const type = layout.type;
                const items = [];
                let changed = false;
                for (const item of layout.items) {
                    const result = this.minimizeLayout(item.child);
                    if (result !== item.child) {
                        changed = true;
                    }
                    if (result) {
                        if (result.type === type) {
                            const childSumFractions = result.items.map((item) => item.fraction).reduce((sum, fraction) => sum + fraction);
                            const normalizedChildFractions = result.items.map((item) => item.fraction / childSumFractions);
                            for (let i = 0; i < result.items.length; i++) {
                                items.push(Object.assign(Object.assign({}, result.items[i]), { fraction: normalizedChildFractions[i] * item.fraction }));
                            }
                            changed = true;
                        }
                        else {
                            items.push(Object.assign(Object.assign({}, item), { child: result }));
                        }
                    }
                }
                if (items.length >= 2) {
                    if (changed) {
                        // Normalize fractions.
                        const fractionSum = items.reduce((sum, item) => sum + item.fraction, 0);
                        const normalizedItems = items.map((item) => {
                            return Object.assign(Object.assign({}, item), { fraction: item.fraction / fractionSum });
                        });
                        return Object.assign(Object.assign({}, layout), { items: normalizedItems });
                    }
                    else {
                        return layout;
                    }
                }
                else if (items.length === 1) {
                    return items[0].child;
                }
                else {
                    return null;
                }
            }
            case 'stack': {
                if (layout.items.length >= 1) {
                    return layout;
                }
                else {
                    return null;
                }
            }
        }
    }
    static findStackItem(predicate, layout) {
        if (layout === null) {
            return null;
        }
        if (layout.type === 'stack') {
            for (const item of layout.items) {
                if (predicate(item.item)) {
                    return item;
                }
            }
        }
        else {
            for (const item of layout.items) {
                const found = StaticUtilities.findStackItem(predicate, item.child);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }
    static findStack(stackItem, from) {
        if (from === null) {
            return null;
        }
        switch (from.type) {
            case 'column':
            case 'row': {
                for (const item of from.items) {
                    const found = StaticUtilities.findStack(stackItem, item.child);
                    if (found) {
                        return found;
                    }
                }
                break;
            }
            case 'stack': {
                for (const item of from.items) {
                    if (stackItem === item) {
                        return from;
                    }
                }
                break;
            }
        }
        return null;
    }
    static getContentResolutionSide(resolution, mousePosition) {
        if (mousePosition.x <= resolution.dropArea.left + resolution.dropArea.width * 0.2) {
            return 'left';
        }
        else if (mousePosition.x >= resolution.dropArea.left + resolution.dropArea.width * 0.8) {
            return 'right';
        }
        else if (mousePosition.y <= resolution.dropArea.top + resolution.dropArea.height * 0.5) {
            return 'top';
        }
        else {
            return 'bottom';
        }
    }
}
//# sourceMappingURL=static-utilities.js.map